<template>
  <section style="">
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            確認進貨
          </p>
        </header>

        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <div class="columns">
              <div class="column">
                <form-group
                  name="name"
                  :label="$t('attributes.name')"
                  label-position="on-border"
                >
                  <b-input
                    v-model="gift_name"
                    name="name"
                    readonly
                    expanded
                    disabled
                  >
                  </b-input>
                </form-group>
                <form-group
                  name="order_number"
                  :label="$t('attributes.gift_order_number')"
                  label-position="on-border"
                >
                  <b-input
                    v-model="form.order_number"
                    name="order_number"
                    readonly
                    expanded
                    disabled
                  >
                  </b-input>
                </form-group>
                <form-group
                  name="voucher_number"
                  attribute="attributes.gift_voucher_number"
                  :label="$t('attributes.gift_voucher_number')"
                  label-position="on-border"
                >
                  <b-input
                    v-model="form.voucher_number"
                    name="voucher_number"
                    placeholder="請輸入科威傳票號碼"
                    expanded
                  >
                  </b-input>
                </form-group>
              </div>
              <div class="column">
                <form-group
                  name="voucher_date"
                  attribute="attributes.gift_voucher_date"
                  :label="$t('attributes.gift_voucher_date')"
                  label-position="on-border"
                >
                  <b-datepicker
                    v-model="voucherDate"
                    :placeholder="
                      $t('message.please_input') +
                        $t('attributes.gift_voucher_date')
                    "
                    icon="calendar-today"
                    inline
                    trap-focus
                    @input="onSelectedDate"
                  >
                    <div class="buttons">
                      <b-button
                        :label="$t('attributes.today')"
                        type="is-success"
                        @click="onSelectedToday"
                      />
                      <b-button
                        :label="$t('attributes.yesterday')"
                        type="is-info"
                        @click="onSelectedYesterday"
                      />
                      <b-button
                        :label="$t('attributes.clear')"
                        type="is-danger"
                        @click="onClearDate"
                      />
                    </div>
                  </b-datepicker>
                </form-group>
              </div>
            </div>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button
            :loading="sending"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ $t('attributes.confirm') }}
          </b-button>
        </footer>

        <b-loading
          :active.sync="sending"
          :is-full-page="false"
          :can-cancel="false"
        ></b-loading>
      </div>
    </form>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'GiftPurchaseImportForm',

  props: {
    giftPurchase: {
      type: Object,
      required: true
    },
    sending: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      gift_name: this.giftPurchase.gift_name,
      voucherDate: null,

      form: {
        voucher_number: null,
        voucher_date: null,
        order_number: this.giftPurchase.order_number
      }
    }
  },
  validations: {
    form: {
      voucher_number: { required },
      voucher_date: { required },
      order_number: { required },
    }
  },
  methods: {
    onSelectedToday() {
      this.voucherDate = this.$dayjs().toDate()
      this.form.voucher_date = this.formatDate(this.voucherDate)
    },
    onSelectedYesterday() {
      this.voucherDate = this.$dayjs()
        .subtract(1, 'day')
        .toDate()
      this.form.voucher_date = this.formatDate(this.voucherDate)
    },
    onClearDate() {
      this.voucherDate = null
      this.form.voucher_date = null
    },
    onSelectedDate(date) {
      this.form.voucher_date = this.formatDate(date)
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
